module.exports = __webpack_public_path__ + "fonts/NunitoSans-Bold.357f8fe.ttf";